import { projectClient } from '../../client/client';

export const paymentMethod = {
  delete: projectClient('/payment/payment-method').delete,
  list: projectClient('/payment/payment-method/list').post,
  setDefault: projectClient('/payment/payment-method/set-default').post,
  setup: projectClient('/payment/payment-method/setup').post,
};
